module.exports = __webpack_public_path__ + "static/media/site_icon.71555210.svg";